import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

const PRICE_PER_KG_TYPE_LABELS = {
    STEEL_PLATE: "Chapa de Aço",
};

export const translatePricePerKgType = (type) => PRICE_PER_KG_TYPE_LABELS[type] || type;

export const getAllPricesPerKg = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.PRICE_PER_KG}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updatePricePerKg = async (id, pricePerKg) => {
    const response = await api.put(`/${ENDPOINTS.PRICE_PER_KG}/${id}`, pricePerKg);
    return response.data;
};
